import React from "react";
import { Music2, Loader2 } from "lucide-react";

const OPTIONS = [
  ["auto", "Auto (rotates weekly)"],
  ["phonk", "Workout energy"],
  ["trap", "Hip-hop"],
  ["drive", "Dance / house"],
  ["lofi", "Lo-fi chill"],
];

export const MusicPicker = ({ post, onUpdate }) => {
  const rendering = post.reel_status === "rendering";
  return (
    <div className="flex items-center gap-2 text-[11px] text-zinc-400" data-testid={`post-music-${post.id}`}>
      {rendering ? <Loader2 className="w-3.5 h-3.5 animate-spin text-[#BEFF38]" /> : <Music2 className="w-3.5 h-3.5 text-[#BEFF38]" />}
      <select
        value={post.music_style || "auto"}
        onChange={(e) => onUpdate({ music_style: e.target.value })}
        disabled={rendering}
        data-testid={`post-music-select-${post.id}`}
        className="bg-zinc-900 border border-zinc-800 rounded-full px-2 py-1 text-[11px] text-white focus:outline-none focus:border-[#BEFF38] disabled:opacity-50"
      >
        {OPTIONS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
      </select>
      <span data-testid={`post-music-label-${post.id}`} title={post.music_credit || ""} className="font-mono uppercase tracking-widest text-[10px] truncate">
        {rendering ? "Adding music…" : post.reel_status === "ready" ? `♫ ${post.music_label}` : post.reel_status === "failed" ? "Music failed — pick a style to retry" : post.image_status === "ready" ? "Queued for music" : ""}
      </span>
    </div>
  );
};
